/**
 * Facts about the site as a whole.
 *
 * The origin is a constant rather than something read from `window.location`,
 * and that is deliberate: a canonical URL computed from wherever the page
 * happens to be served would let a preview deployment declare itself the
 * canonical copy of every lesson. Build scripts may override it with
 * `SITE_ORIGIN` when generating a staging build; the browser never does.
 */

import { BRAND } from '@yuan-math/config';

export const SITE = {
  origin: 'https://yuan-math.com',
  name: BRAND.name,
  tagline: BRAND.tagline,
  /** BCP-47, and `og:locale`'s underscored spelling of the same thing. */
  lang: 'en',
  ogLocale: 'en_US',
  /**
   * The social card. One image for the whole site.
   *
   * Per-page cards would need an image renderer at request time, which means a
   * server, which this platform does not have and does not want — see the
   * privacy promise. A single honest brand card costs nothing and cannot be
   * wrong.
   */
  image: {
    path: '/og-image.png',
    width: 1200,
    height: 630,
    alt: 'Yuan Math — mathematics from kindergarten to university, drawn as a path of connected concepts.',
  },
  /** The brand green, for the browser chrome on mobile. */
  themeColor: '#58cc02',
} as const;

/** Absolute URL for a site-root-relative path. */
export function absoluteUrl(path: string, origin: string = SITE.origin): string {
  const base = origin.replace(/\/+$/, '');
  if (path === '/') return `${base}/`;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
